export const trimSearchQuery = (query: string): string => {
  const trimmed = query
    .replace(/[,;\\"]+/g, ' ')
    .split(' ')
    .filter(p => !!p)
    .join(' ');
  return trimmed;
};
